import { render, staticRenderFns } from "./InquiryManagement.vue?vue&type=template&id=b0aa94dc&"
import script from "./InquiryManagement.vue?vue&type=script&lang=js&"
export * from "./InquiryManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports